<template>
    <div>
        <div class="card">
            <div class="card-header">反馈问卷信息</div>
            <table class="table table-bordered mb-0">
                <tbody>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">应评</th>
                    <td class="text-left align-middle" style="width: 15%">{{surveyData.length}}</td>
                    <th class="text-center align-middle" style="width: 10%">实评</th>
                    <td class="text-left align-middle" style="width: 15%">{{submitCount}}</td>
                    <th class="text-center align-middle" style="width: 10%">评分</th>
                    <td class="text-left align-middle" style="width: 15%"><template v-if="canViewDetail">{{paperScore}}</template></td>
                    <th class="text-center align-middle" style="width: 10%">状态</th>
                    <td class="text-left align-middle" style="width: 15%">{{surveyPaperInfo.stateName}}</td>
                </tr>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">评价<br />内容</th>
                    <td class="text-left align-middle" colspan="7">
                        <div v-if="paperContent.lowScoreContent.length!==0">
                            <p class="font-weight-bold">客观项低分原因：</p>
                            <ul class="">
                                <li v-for="item in paperContent.lowScoreContent">
                                    <div>
                                        <p class="mb-0">{{ item.title }}</p>
                                        <p class="mb-0">{{ item.content }}<template v-if="canViewDetail">  —— {{item.studentName}} {{item.collegeName}}</template></p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <p class="font-weight-bold">主观评价项评价内容：</p>
                            <ul class="mb-0">
                                <li v-for="item in paperContent.content">
                                    <div>
                                        <p class="font-weight-bold">{{item.title}}</p>
                                        <ul>
                                            <li v-for="s in item.contentData">
                                                {{ s.content }}<template v-if="canViewDetail">  —— {{s.studentName}} {{s.collegeName}}</template>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="card-footer text-center">
                <button class="btn btn-danger" @click="btnSubmitSurvey_Click">关闭反馈</button>
            </div>
        </div>

        <div class="card mt-3">
            <div class="card-header">反馈详情</div>
            <table class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">序号</th>
                    <th class="text-center align-middle" style="width: 10%">姓名</th>
                    <th class="text-center align-middle" style="width: 40%">所属院校</th>
                    <th class="text-center align-middle" style="width: 10%">反馈</th>
                    <th class="text-center align-middle" style="width: 20%">反馈时间</th>
                    <th class="text-center align-middle" style="width: 10%">详情</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in surveyData" >
                    <td class="text-center align-middle">{{index+1}}</td>
                    <td class="text-center align-middle">{{item.studentName}}</td>
                    <td class="text-left align-middle">{{item.collegeName}}</td>
                    <td class="text-center align-middle">{{item.surveyScore? '已评价': '未评价'}}</td>
                    <td class="text-center align-middle">{{item.createDateTimeString}}</td>
                    <td class="text-center align-middle">
                        <button class="btn btn-info btn-sm" @click="btnShowSurveyDetailInfo_Click(item.surveyId)" :disabled="!item.surveyId || !canViewDetail">详情</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <b-modal v-model="isSurveyDetailViewDialogOpen"
                 title="参训教师反馈问卷信息详情" size="lg"
                 :hide-footer="true"
                 :no-close-on-backdrop="true">
            <survey-detail-view :survey-id="currentSurveyId"></survey-detail-view>
        </b-modal>
    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
import dictionary from "@/utils/dictionary";
import SurveyDetailView from "@/components/study/SurveyDetailView";
export default {
    name: "SurveyPaperDetailEdit",
    props: {
        surveyTemplateId: {type: String, required: true},
        surveyPaperId: {type: String, required: true},
        classId: {type: String, required: true},
    },
    components: {
        SurveyDetailView
    },
    data: function () {
        return {
            surveyTemplateInfo: {},
            surveyPaperInfo: {},

            surveyData: [],

            currentSurveyId: '',
            isSurveyDetailViewDialogOpen: false,
        };
    },
    computed: {
        canViewDetail() {
            return this.$store.state.userType === dictionary.userType.ADMIN;
        },
        submitCount() {
            let result = 0;
            for (let item of this.surveyData) {
                if (item.surveyId) {
                    result++;
                }
            }
            return result;
        },
        paperScore() {
            let scoreItems = this.surveyData.filter(item => item.surveyId).map(item => item.surveyScore).sort((a, b) => a.surveyScore - b.surveyScore);

            if (this.surveyTemplateInfo.excludeMinCount !== 0) {
                scoreItems = scoreItems.filter((item, index) => index>=this.surveyTemplateInfo.excludeMinCount);
            }
            if (this.surveyTemplateInfo.excludeMaxCount !== 0) {
                scoreItems = scoreItems.filter((item, index) => index<scoreItems.length-this.surveyTemplateInfo.excludeMaxCount);
            }

            let sum = 0;
            for (let item of scoreItems) {
                sum += item;
            }

            let result = 0;
            if (scoreItems.length !== 0) {
                result = Math.round(sum*100/scoreItems.length)/100;
            }
            return result;
        },
        paperContent() {
            let result = {
                lowScoreContent: [],
                content: []
            };

            this.surveyData.filter(item => item.surveyId).forEach(survey => {
                survey.scoreItems.forEach(item => {
                    if (item.content) {
                        result.lowScoreContent.push({
                            studentId: survey.studentId,
                            studentName: survey.studentName,
                            collegeName: survey.collegeName,
                            title: item.title,
                            content: item.content
                        });
                    }
                })

                survey.contentItems.forEach((item, index) => {
                    if (!result.content[index]) {
                        result.content[index] = {
                            title:item.title,
                            contentData: []
                        };
                    }

                    if (item.content) {
                        result.content[index].contentData.push({
                            studentId: survey.studentId,
                            studentName: survey.studentName,
                            collegeName: survey.collegeName,
                            content: item.content
                        });
                    }
                });
            });

            return result;
        }
    },
    mounted() {
        this.getSurveyTemplateInfo();
        this.getSurveyPaperInfo();
        this.getSurveyData();
    },
    methods: {
        getSurveyTemplateInfo() {
            studyApi.survey.template.getSurveyTemplateInfo(this.surveyTemplateId).then(res => {
                this.surveyTemplateInfo = res.data;
            });
        },
        getSurveyPaperInfo() {
            studyApi.survey.paper.getSurveyPaperInfo(this.surveyPaperId).then(res => {
                this.surveyPaperInfo = res.data;
            });
        },

        getSurveyData() {
            studyApi.survey.getSurveyData(this.surveyPaperId, this.classId).then(res => {
                let result = res.data;
                for (let item of result) {
                    item.scoreItems = JSON.parse(item.scoreDetail);
                    item.contentItems = JSON.parse(item.contentDetail);
                }
                console.info(result)
                this.surveyData = result;
            });
        },

        btnSubmitSurvey_Click() {
            if (confirm('是否提交反馈？提交后参训教师将不能再填写此反馈问卷')) {
                let info = {
                    surveyPaperId: this.surveyPaperId,
                    submitStudentCount: this.submitCount,
                    surveyScore: this.paperScore,
                    surveyContent: JSON.stringify(this.paperContent),
                    state: dictionary.surveyPaperState.COMPLETED
                };
                console.info(info)
                studyApi.survey.paper.updateSurveyPaperInfo(info).then(res => {
                    alert('反馈问卷已关闭');
                    this.$emit('close');
                });
            }
        },

        btnShowSurveyDetailInfo_Click(surveyId) {
            this.currentSurveyId = surveyId;
            this.isSurveyDetailViewDialogOpen = true;
        }
    }
}
</script>

<style scoped>

</style>